import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { ListMouComponent } from '@app-admin/dialogs/list-mou/list-mou.component';
import { ManageAdminsComponent } from '@app-admin/dialogs/manage-admins/manage-admins.component';
import { ManageSystemAdminsComponent } from '@app-admin/dialogs/manage-system-admins/manage-system-admins.component';
import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';
import { DialogService } from './dialogs/dialog.service';
import { UploadMouComponent } from './dialogs/upload-mou/upload-mou.component';
import { features } from 'process';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(
    private dialog: MatDialog,
    private util: UtilService,
    private api: ApiService,
    private dialogSrvc: DialogService
  ) {}

  get userRole(): string | null {
    const value = localStorage.getItem('ur');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  get jwt(): string | null {
    return localStorage.getItem('JwtToken');
  }

  get orgID(): string | null {
    const value = localStorage.getItem('OrgId');
    if (value) {
      return this.util.decrypt(value);
    }
    return null;
  }

  getOrgDetails(currentOrgID: number) {
    const postData: APIRequest = {
      requestBody: {
        orgID: currentOrgID,
      },
    };

    return this.api.post(URL.ADMIN.GET_ORG_BY_ID, postData);
  }

  getUserOrgId() {
    return this.orgID;
  }

  getFeaturesByPlan(data: any) {
    const postData: APIRequest = {
      requestBody: {
        plan_id: data.plan_id
      },
    };

    return this.api.post(URL.ADMIN.GET_FEATURES_BY_PLAN, postData);
  }

  updatePlanByID(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data
      },
      requestHead: {
        appName: 'Certiplate UI',
        platform: 'web'
      }
    };
    return this.api.post(URL.ADMIN.UPDATE_SUBSCRIPTION_PLAN, postData);
  }
  createSubscriptionPlan(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data
      },
      requestHead: {
        appName: 'Certiplate UI',
        platform: 'web'
      }
    };
    return this.api.post(URL.ADMIN.CREATE_SUBSCRIPTION_PLAN, postData);
  }

  getPlanById(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data
      },
      requestHead: {
        appName: 'Certiplate UI',
        platform: 'web'
      }
    };
    return this.api.post(URL.ADMIN.GET_PLAN_BY_ORG_ID, postData);
  }

  savePlanByOrgId(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data
      },
      requestHead: {
        appName: 'Certiplate UI',
        platform: 'web'
      }
    };

    return this.api.post(URL.ADMIN.SAVE_PLAN_BY_ORG_ID, postData);
  }

  checkPlanOrgLinks(planId: any) {
    const postData: APIRequest = {
      requestBody: {
        plan_id: planId
      },
      requestHead: {
        appName: 'Certiplate UI',
        platform: 'web'
      }
    };

    return this.api.post(URL.ADMIN.CHECK_PLAN_ORG_LINKS, postData);
  }

  deleteSubscriptionPlan(planId: any) {
    const postData: APIRequest = {
      requestBody: {
        plan_id: planId
      },
      requestHead: {
        appName: 'Certiplate UI',
        platform: 'web'
      }
    };

    return this.api.post(URL.ADMIN.DELETE_SUBSCRIPTION_PLAN, postData);
  }
  
  createOrUpdateOrg(data: any) {
    const postData: APIRequest = {
      requestBody: {
        name: data.name,
        geography_id: data.geography_id,
        pincode_id: data.pincode_id,
        is_ldap_integration_enabled: data.isLDAPrequired === 'true',
        logo_file_name: data.logoSource,
        industry_vertical_id: parseInt(data.indVertical),
        default_modules: data.default_modules,
        course_framework_ids: data.courseFrameworkIds,
        state_name: data.state,
        district_name: data.district,
        billing_address: data.billingAddress,
        org_id: data.org_id,
      },
    };

    return this.api.post(URL.ADMIN.CREATE_OR_UPDATE_ORG, postData);
  }

  manageAdminDialog(orgID: any) {
    const dialogRef = this.dialog.open(ManageAdminsComponent, {
      width: 'min(1200px, 92vw)',
      maxWidth: '1200px',
      panelClass: 'manage-admin-dialog',
      data: orgID,
      autoFocus: false,
    });
    ////(this.dialog.openDialogs)
    dialogRef.afterClosed().subscribe((result) => {
      ////(`Dialog result: ${result}`);
    });
  }

  manageSystemAdminDialog() {
    // Opens the dedicated System Super Admin dialog (organization_id = -1)
    const sysRef = this.dialog.open(ManageSystemAdminsComponent, {
      width: 'min(1000px, 92vw)',
      data: -1,
      autoFocus: false,
    });
    sysRef.afterClosed().subscribe(() => {});
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  manageMOUDialog(orgId) {
  this.dialogSrvc.getMOUs(parseInt(orgId)).subscribe(
    (res_data: any) => {
        const mouList = res_data.body.responseBody || [];
        const tableData = mouList.map((element, index) => {
          return { ...element, sno: index + 1, agreement_file_name: this.getMouFileDisplayName(element.agreement_file) };
        });

        if (tableData.length === 0) {
          // No records — directly open upload, skip list
          this.openUploadMOU({ orgId, isNew: true, agreementDateRanges: [] });
        } else {
          const dialogRef = this.dialog.open(ListMouComponent, {
            width: 'min(1200px, 92vw)',
            maxWidth: '1200px',
            maxHeight: '80vh',
            autoFocus: false,
            panelClass: 'list-mou-dialog',
            data: {
              orgId,
              encId: this.util.encrypt(`${orgId}`),
              orgName: this.getOrgName(orgId),
              mouList: tableData
            }
          });

          dialogRef.afterClosed().subscribe(() => {});
      }
    },
    (err: any) => {
      this.util.errorNotification(err);
    }
  );
  }

  private getMouFileDisplayName(agreement_file: string): string {
    if (!agreement_file) return '-';
    if (agreement_file.startsWith('data:')) return 'MOU File';
    const lastSlash = agreement_file.lastIndexOf('/');
    const name = lastSlash !== -1 ? agreement_file.slice(lastSlash + 1) : agreement_file;
    return name || 'MOU File';
  }

  // Helper method to get organization name
   private getOrgName(orgId: any): string {
    // Try to get from localStorage first
    const selectedOrg = localStorage.getItem('SelectedOrgForRevision');
    if (!selectedOrg) return 'Organization';

    // selectedOrg may be plain JSON (stringified) or an encrypted string.
    // Try JSON.parse first; if it fails, attempt to decrypt then parse.
    try {
      const orgData = JSON.parse(selectedOrg);
      if (orgData && orgData.id == orgId) {
        return orgData.name;
      }
    } catch (e) {
      try {
        const decrypted = this.util.decrypt(selectedOrg);
        const orgData = JSON.parse(decrypted);
        if (orgData && orgData.id == orgId) {
          return orgData.name;
        }
      } catch (e2) {
        console.warn('Unable to parse SelectedOrgForRevision from localStorage', e2);
      }
    }

    return 'Organization';
  }

  openUploadMOU(data: any, parentDialogRef?: MatDialogRef<any>) {
    if (parentDialogRef) {
      parentDialogRef.close();

      setTimeout(() => {
        const uploadDialogRef = this.dialog.open(UploadMouComponent, {
          width: 'min(980px, 92vw)',
          maxWidth: '980px',
          autoFocus: false,
          data,
          panelClass: 'upload-mou-dialog'
        });

        // Handle upload success - refresh and show list
        uploadDialogRef.afterClosed().subscribe((result) => {
          if (result && result.success) {
            // Refresh MOU data and show list
            this.refreshAndShowMOUList(data.orgId);
          } else if (result && result.cancelled) {
            // User cancelled upload, check if we should show list
            this.checkAndShowMOUList(data.orgId);
          }
        });
      }, 300); // Give time for dialog to close smoothly
    } else {
      const uploadDialogRef = this.dialog.open(UploadMouComponent, {
        width: 'min(980px, 92vw)',
        maxWidth: '980px',
        autoFocus: false,
        data,
        panelClass: 'upload-mou-dialog'
      });

      // Handle upload success - refresh and show list
      uploadDialogRef.afterClosed().subscribe((result) => {
        if (result && result.success) {
          // Refresh MOU data and show list
          this.refreshAndShowMOUList(data.orgId);
        } else if (result && result.cancelled) {
          // User cancelled upload, check if we should show list
          this.checkAndShowMOUList(data.orgId);
        }
      });
    }
  }

  refreshAndShowMOUList(orgId: any) {
    this.dialogSrvc.getMOUs(parseInt(orgId)).subscribe(
      (res_data: any) => {
        const mouList = res_data.body.responseBody || [];
        const tableData = mouList.map((element, index) => {
          return { ...element, sno: index + 1, agreement_file_name: this.getMouFileDisplayName(element.agreement_file) };
        });

        if (tableData.length > 0) {
          this.dialog.open(ListMouComponent, {
            width: 'min(1000px, 92vw)',
            maxHeight: '80vh',
            autoFocus: false,
            data: {
              orgId,
              encId: this.util.encrypt(`${orgId}`),
              orgName: this.getOrgName(orgId),
              mouList: tableData
            }
          });
        }
      },
      (err: any) => { this.util.errorNotification(err); }
    );
  }

  checkAndShowMOUList(orgId: any) {
    this.dialogSrvc.getMOUs(parseInt(orgId)).subscribe(
      (res_data: any) => {
        const mouList = res_data.body.responseBody || [];
        const tableData = mouList.map((element, index) => {
          return { ...element, sno: index + 1, agreement_file_name: this.getMouFileDisplayName(element.agreement_file) };
        });

        if (tableData.length > 0) {
          this.dialog.open(ListMouComponent, {
            width: 'min(1000px, 92vw)',
            maxHeight: '80vh',
            autoFocus: false,
            data: {
              orgId,
              encId: this.util.encrypt(`${orgId}`),
              orgName: this.getOrgName(orgId),
              mouList: tableData
            }
          });
        }
      },
      (err: any) => { this.util.errorNotification(err); }
    );
  }

  uploadIimage(data: any) {
    const postData: APIRequest = {
      requestBody: {
       ...data,
      },
    }
    return this.api.post(URL.ADMIN.UPLOAD_FILES, postData);
  }

  download(data: any) {
    const postData: APIRequest = {
      requestBody: {
       ...data,
      },
    }
    return this.api.post(URL.ADMIN.DOWNLOAD, postData);
  }
  downloadcourse_version_assessmentPlan_bluePrint(data :any,topic : String)
  {
    const postData: APIRequest = {
      requestBody: {
        'key' : data,
        'topic' : topic
      },
    }
    return this.api.post(URL.ADMIN.DOWNLOAD, postData);

  }
  getCourseVersionDetail(data : any){
    const postData: APIRequest = {
      requestBody: {
       data,
      },
    }
    return this.api.post(URL.ANALYSIS.get_Courses_VersionBy_Detail_Id, postData);
  }

  /**
   * Get all organizations for super admin
   * Returns complete list of all organizations in the system
   */
  getAllOrganizations() {
    const postData: APIRequest = {
      requestBody: {},
    };
    return this.api.post(URL.ADMIN.LIST_ORGS, postData);
  }
  
}

